import React, { createContext, useContext, useState, useEffect } from 'react';
import { obtenerUsuarioAutenticado, logoutUsuario } from '../../api';
import { useNavigate } from "react-router-dom";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const verificarAutenticacion = async () => {
    try {
      console.log('[AuthProvider] Verificando autenticación...');
      const userData = await obtenerUsuarioAutenticado();

      if (userData && userData.role === "admin") {
        console.log('[AuthProvider] Admin autenticado:', userData);
        setUser(userData);
        setIsLoggedIn(true);
      } else {
        console.warn('[AuthProvider] Acceso denegado: no es admin');
        setUser(null);
        setIsLoggedIn(false);
      }
    } catch (err) {
      console.error('[AuthProvider] Error al verificar usuario:', err);
      setIsLoggedIn(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    verificarAutenticacion();
  }, []);

  const logout = async () => {
    try {
      await logoutUsuario();
      setUser(null);
      setIsLoggedIn(false);
      navigate("/admin/login");
    } catch (error) {
      console.error('Error al cerrar sesión', error);
    }
  };

  if (loading) return <div>Loading...</div>;

  return (
    <AuthContext.Provider value={{ user, isLoggedIn, logout, verificarAutenticacion }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useUser = () => useContext(AuthContext);
